export default __webpack_public_path__ + "5d69598eba004b778f74b62a86a30695.png";